import Global from "app/fuse-configs/Global";

export const log = (content) => {
  if (Global.debugMode) {
    // eslint-disable-next-line no-undef
    console.log("[IDCongress Debugger]: ", content);
  }
};
